import { Policy } from "@covertree/agent-portal-graphql";
import { restApi } from "@redux/restApi";

interface UploadDocumentsPayload {
  policyLocator: string;
  isSignedManually: boolean;
  file: File;
}

export interface UploadDocumentsResponse {
  policy: Policy;
  error: string;
}

export const documentsRestApi = restApi.injectEndpoints({
  endpoints: (build) => ({
    uploadPolicyDocuments: build.mutation<
      UploadDocumentsResponse,
      UploadDocumentsPayload
    >({
      query: ({ file, policyLocator, isSignedManually }) => {
        const formData = new FormData();
        formData.append("files", file);
        formData.append("isSignedManually", String(isSignedManually));

        return {
          url: `policies/${encodeURIComponent(policyLocator)}/documents`,
          method: "POST",
          mode: "cors",
          body: formData,
        };
      },
    }),
  }),
});

export const { useUploadPolicyDocumentsMutation } = documentsRestApi;
